// extracted by mini-css-extract-plugin
export default {"management_box":"construction_management_box__8j-Pp","textform":"construction_textform__lKqbA","option_box":"construction_option_box__sEN1H"};